<template>
  <!-- <ElDialog v-model="isShow" width="530px" :show-close="false" class="form-dialog"> -->
  <component
    :is="appStore.isMobile ? ElDrawer : ElDialog"
    v-model="isShow"
    width="530px"
    size="100%"
    :show-close="false"
    class="form-dialog"
    :class="{ 'mobile-drawer': appStore.isMobile }"
    append-to-body
  >
    <img v-if="!appStore.isMobile" class="close" src="@/assets/images/close.png" alt="close" @click="isShow = false" />
    <img
      v-if="appStore.isMobile"
      class="close"
      src="@/assets/images/H5/close.png"
      alt="close"
      @click="isShow = false"
    />

    <div class="top">
      <div class="title">
        <img src="@/assets/images/Login/title.png" alt="" />
      </div>

      <div class="logo">
        <img src="@/assets/images/logo.png" alt="" />
      </div>
    </div>

    <div class="nav">
      <div :class="{ actived: actived === 'login' }" @click="actived = 'login'">
        <span>登录 Login</span>
      </div>
      <div :class="{ actived: actived === 'register' }" @click="actived = 'register'">
        <span>注册 Register</span>
      </div>
    </div>

    <div class="form-content">
      <ElForm ref="formRef" :model="formData" label-position="top" :rules="rules">
        <ElFormItem prop="username">
          <template #label>
            <div class="f-label">
              <img class="label-icon" src="@/assets/images/Login/un.png" alt="un" />
              <span>用户名 Username</span>
            </div>
          </template>
          <ElInput v-model="formData.username" placeholder="请输入用户名 Please enter your username" />
        </ElFormItem>

        <ElFormItem prop="password">
          <template #label>
            <div class="f-label">
              <img class="label-icon" src="@/assets/images/Login/pw.png" alt="un" />
              <span>密码 Password</span>
            </div>
          </template>
          <ElInput v-model="formData.password" type="password" show-password placeholder="请输入密码 Please enter your password" />
        </ElFormItem>

        <ElFormItem prop="passwordRepeat" v-if="actived === 'register'">
          <template #label>
            <div class="f-label">
              <img class="label-icon" src="@/assets/images/Login/pw.png" alt="un" />
              <span>确认密码 Confirm Password</span>
            </div>
          </template>
          <ElInput v-model="formData.passwordRepeat" type="password" show-password placeholder="请再次输入密码 Please re-enter your password" />
        </ElFormItem>

        <ElFormItem prop="code" label="验证码">
          <template #label>
            <div class="f-label">
              <img class="label-icon" src="@/assets/images/Login/code.png" alt="un" />
              <span>验证码 Verification code</span>
              <img class="code-item" :src="codeImg" alt="code" @click="getCode" />
            </div>
          </template>
          <ElInput v-model="formData.code" placeholder="请输入验证码 Please enter the verification code" />
        </ElFormItem>

        <ElFormItem class="formitem-btn">
          <ElButton class="btn" @click="clickRegister" :loading="loading">
            {{ actived === 'register' ? '注册 Register' : '登录 Login' }}
          </ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </component>
</template>

<script setup lang="ts">
import { ref, defineExpose, computed, watch } from 'vue'
import { getVerCode, registerAccount, loginAccount } from '@/api'
import encryptTools from '@/utils/encrypt'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import { useAppStore } from '@/stores/app'
import { ElDrawer, ElDialog } from 'element-plus'

const appStore = useAppStore()

const checkRepeatPwd = (_: any, value: string, cb: (a?: any) => void) => {
  const oldPwd = formData.value.password

  if (oldPwd !== value) {
    cb(new Error('两次密码不一致 Passwords do not match'))
    return
  }

  cb()
}

const user = useUserStore()
const loading = ref(false)
const isShow = computed({
  get() {
    return user.showLogin
  },
  set(bol) {
    user.setShowLogin(bol)
  },
})

const formData = ref({
  username: '',
  password: '',
  passwordRepeat: '',
  code: '',
})
const codeImg = ref('')
const formRef = ref()
const actived = ref('login')
const rules = ref({
  username: [{ required: true, message: '请输入用户名 Please enter your username', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码 Please enter your password', trigger: 'blur' }],
  passwordRepeat: [
    { required: true, message: '请输入密码 Please enter your password', trigger: 'blur' },
    { validator: checkRepeatPwd, trigger: 'blur' },
  ],
  code: [{ required: true, message: '请输入验证码 Please enter the verification code', trigger: 'blur' }],
})

const open = () => {
  getCode()
  formData.value = {
    username: '',
    password: '',
    passwordRepeat: '',
    code: '',
  }
  codeImg.value = ''
  // isShow.value = true
}

watch(isShow, (n) => {
  if (n) {
    open()
  }
})

const getCode = async () => {
  try {
    const res = await getVerCode()
    codeImg.value = window.URL.createObjectURL(res)
  } catch {}
}

const register = async () => {
  try {
    const { data, message } = await registerAccount({
      userName: formData.value.username,
      password: encryptTools.RSAencrypt(formData.value.password),
      imgVerificationCode: formData.value.code,
    })

    if (data) {
      ElMessage.success('注册成功 Registration successful')
      isShow.value = false
    } else {
      ElMessage.error(message)
    }
  } catch {
  } finally {
    loading.value = false
  }
}

const login = async () => {
  try {
    const { data, message } = await loginAccount({
      userName: formData.value.username,
      password: encryptTools.RSAencrypt(formData.value.password),
      imgVerificationCode: formData.value.code,
    })

    if (data) {
      ElMessage.success('登录成功 Login successful')

      user.setIsLogin(true)
      user.setInfo()
      isShow.value = false
    } else {
      ElMessage.error(message)
    }
  } catch {
    getCode()
  } finally {
    loading.value = false
  }
}

const clickRegister = async () => {
  await formRef.value?.validate?.()

  loading.value = true

  if (actived.value === 'login') {
    login()
  } else {
    register()
  }
}

defineExpose({ open })
</script>

<style lang="less">
@import '@/assets/H5/Login.less';
</style>

<style lang="less" scoped>
.code-item {
  height: 46px;
  width: auto;
  margin-left: 10px;
  cursor: pointer;
}

.top {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;

  .logo img {
    display: block;
    height: 52px;
    width: auto;
  }

  .title {
    margin-right: 20px;

    img {
      display: block;
      height: 37px;
      width: auto;
    }
  }
}

.close {
  width: 28px;
  height: 28px;
  position: absolute;
  top: 13px;
  right: 17px;
  cursor: pointer;
}

.nav {
  padding: 15px 0 13px;
  display: flex;
  color: #767676;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 1px solid #0000001a;

  > div {
    width: 50%;
    text-align: center;
    cursor: pointer;

    &.actived {
      span {
        color: #c78b45;

        &::after {
          width: 100%;
          height: 3px;
          background-color: #c78b45;
        }
      }
    }

    span {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 0;
      }
    }
  }
}

.form-content {
  padding: 20px 41px;
  color: #333;

  :deep(.el-form-item__label) {
    &::before {
      display: none;
    }
  }

  :deep(.el-input) {
    height: 48px;

    .el-input__wrapper {
      --el-input-focus-border-color: #c78b45;

      background-color: #f4f4f4;
      border: 1px solid #f0ece4;
      border-radius: 12px;
    }
  }
}

.label-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.f-label {
  display: flex;
  align-items: center;

  span {
    color: #333;
    font-weight: 600;
    font-size: 16px;
  }
}

.btn {
  margin-top: 24px;
  width: 100%;
  height: 48px;
  background:
    radial-gradient(139.54% 111.46% at 53.7% -11.46%, #fadec5 0%, #c5a68b 61.54%, #dbbfa7 100%),
    radial-gradient(72.9% 34.37% at 50% 0%, rgba(255, 255, 255, 0.32) 0%, rgba(255, 255, 255, 0) 79.06%);
  background-blend-mode: overlay;
  box-shadow:
    0px 1px 2px 0px rgba(38, 26, 23, 0.3),
    inset 0px 0px 4.8px 0px rgba(255, 255, 255, 0.9);
  border: 1px solid transparent;
  border-image-slice: 1;
  border-radius: 40px;
  font-size: 20px;
  color: #fff;
  font-weight: 500;
}
</style>

<style lang="less">
.form-dialog {
  padding: 0;
  border-radius: 20px;
  z-index: 3;

  .el-dialog__body {
    background: url('@/assets/images/Login/bg.png') center top / contain no-repeat;
    border-radius: 20px;
  }

  .el-dialog__header {
    display: none;
  }
}
</style>
